import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useState } from 'react';
import { UserProfileModal } from '../UserProfileModal';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: '⬡' },
  { to: '/chat',    label: 'Chat Manager', icon: '💬'},
  { to: '/sessions',label: 'Lịch sử đoạn chat',  icon: '📝' },
  { to: '/api-keys',label: 'API Keys',  icon: '🔑' },
  { to: '/billing', label: 'Billing & Usage', icon: '💳' },
  { to: '/nodes',   label: 'AI Nodes',  icon: '🤖', adminOnly: true },
  { to: '/test',    label: 'Live Test', icon: '⚡', adminOnly: true },
  { to: '/projects',label: 'Code Repositories',  icon: '🗂️', adminOnly: true },
];


const WORKER_URL = import.meta.env.VITE_API_BASE ?? window.location.origin;

export function Layout() {
  const { user, logout } = useAuth();
  const [showProfile, setShowProfile] = useState(false);

  return (
    <div className="app-layout">
      {/* Header */}
      <header className="app-header">
        {/* Status pill */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{
            width: 7, height: 7, borderRadius: '50%',
            background: 'var(--accent-green)',
            boxShadow: '0 0 6px var(--accent-green)',
            display: 'inline-block',
            animation: 'pulse-dot 2s ease-in-out infinite',
          }} />
          <span style={{ fontSize: '11px', color: 'var(--text-muted)', fontFamily: 'var(--font-mono)' }}>
            {WORKER_URL.replace('https://', '').replace('http://', '')}
          </span>
        </div>

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '12px' }}>
          {user ? (
            <>
              <button 
                onClick={() => setShowProfile(true)}
                style={{ 
                  background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px',
                  padding: '4px 8px', borderRadius: '4px', transition: 'background 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.background = 'var(--bg-elevated)'}
                onMouseOut={(e) => e.currentTarget.style.background = 'none'}
              >
                <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                  {user.username}
                </span>
                <span className={`badge badge--${user.role === 'admin' ? 'purple' : 'blue'}`}>
                  {user.role}
                </span>
              </button>
              <button className="btn btn--secondary btn--sm" onClick={logout}>
                Sign out
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login" className="btn btn--secondary btn--sm" style={{ textDecoration: 'none' }}>Đăng nhập</NavLink>
              <NavLink to="/login" className="btn btn--primary btn--sm" style={{ textDecoration: 'none' }}>Đăng ký</NavLink>
            </>
          )}
        </div>
      </header>

      {/* Sidebar */}
      <aside className="app-sidebar">
        <div className="nav-logo">
          <div className="nav-logo__symbol">E</div>
          <div>
            <span className="nav-logo__name">Erix Life</span>
            <div style={{ fontSize: '9px', color: 'var(--text-muted)', marginTop: '1px' }}>Enterprise Agentic OS</div>
          </div>
        </div>

        <div className="nav-section">
          <div className="nav-section__label">Platform</div>
          {NAV_ITEMS.filter(item => !item.adminOnly || user?.role === 'admin').map(item => (
            <NavLink
              key={item.to}
              to={user || item.to === '/chat' ? item.to : '/login'}
              onClick={(e) => {
                if (!user && item.to !== '/chat') {
                  alert('Vui lòng đăng nhập hoặc đăng ký tài khoản để sử dụng tính năng này!');
                }
              }}
              className={({ isActive }) => `nav-item${isActive && (user || item.to === '/chat') ? ' active' : ''}`}
              style={{ opacity: !user && item.to !== '/chat' ? 0.6 : 1 }}
            >
              <span className="nav-item__icon">{item.icon}</span>
              {item.label}
              {!user && item.to !== '/chat' && <span style={{ marginLeft: 'auto', fontSize: '10px' }}>🔒</span>}
            </NavLink>
          ))}
        </div>

        {user?.role === 'admin' && (
          <div className="nav-section" style={{ marginTop: '16px' }}>
            <div className="nav-section__label">Admin</div>
            <NavLink to="/admin/users" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              <span className="nav-item__icon">👥</span>
              Users & Quota
            </NavLink>
            <NavLink to="/admin/plans" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              <span className="nav-item__icon">💎</span>
              Billing Plans
            </NavLink>
            <NavLink to="/admin/prompt-forge" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              <span className="nav-item__icon">🔥</span>
              Prompt Forge (RLHF)
            </NavLink>
            <NavLink to="/admin/swarm-v2" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              <span className="nav-item__icon">⚡</span>
              Swarm V2
            </NavLink>
          </div>
        )}

        {/* Endpoint info */}
        <div style={{ marginTop: 'auto', padding: '12px 8px', borderTop: '1px solid var(--border)' }}>
          <div style={{ fontSize: '10px', color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '8px' }}>
            OpenAI Endpoint
          </div>
          <div style={{
            background: 'rgba(6,182,212,0.08)',
            border: '1px solid rgba(6,182,212,0.2)',
            borderRadius: '6px',
            padding: '8px',
          }}>
            <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '3px' }}>Base URL</div>
            <code style={{ fontSize: '10px', color: '#22d3ee', fontFamily: 'var(--font-mono)', wordBreak: 'break-all', display: 'block' }}>
              {WORKER_URL}/v1
            </code>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="app-content">
        <Outlet />
      </main>

      {showProfile && <UserProfileModal onClose={() => setShowProfile(false)} />}
    </div>
  );
}
